import { TabsProps } from "@/common/components/Tabs";
import { MaintenaceWorkflowData } from "../types/maintenanceWorkflows.type";
import { createElement } from "react";
import { maintenanceForwardingsDirectiveEntryKlasses } from "../constants/forwardings/maintenanceForwardingsDirectiveEntryKlasses.constant";
import MaintenanceWorkflowForwardingShow from "../pages/Show/components/tabs/ForwardingsTab/MaintenanceWorkflowForwardingShow";

export const getWorkflowTabsList = (
  workflow: MaintenaceWorkflowData | undefined,
) => {
  let forwardingsDirectiveEntryKlassesTabs: TabsProps['tabsList'] = [];

  if (workflow?.current_forwarding?.directive_entry_type) {
    const tab = maintenanceForwardingsDirectiveEntryKlasses[workflow?.current_forwarding?.directive_entry_type];

    if (tab) {
      forwardingsDirectiveEntryKlassesTabs = [
        {
          value: '',
          label: tab.label,
          body: createElement(MaintenanceWorkflowForwardingShow, { workflow }),
        },
      ];
    }
  }

  return [
    ...forwardingsDirectiveEntryKlassesTabs,
  ] as TabsProps['tabsList'];
}
